import { pxToRem } from '@back-office/core';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import CloseIcon from '@material-ui/icons/Close';
import { DateRange, DateRangePicker } from '@material-ui/pickers';
import clsx from 'clsx';
import React, { FC, MouseEvent } from 'react';
import { getDatetimeText } from '../../utils';

const useStyles = makeStyles(
  (theme) => ({
    icon: {
      color: theme.palette.common.hitGray,
      width: pxToRem(20),
      height: pxToRem(20),
    },
    container: {
      padding: theme.spacing(1),
      border: '1px solid #C4C4C4',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '6px',
      height: '100%',
      color: theme.palette.common.hitGray,
      '& > .MuiButton-label': {
        display: 'flex',
        gap: `${theme.spacing(1)}px`,
      },
      '&:hover': {
        border: `1px solid ${theme.palette.common.ceriseRed}`,
        color: theme.palette.common.ceriseRed,
        backgroundColor: 'unset',
        '& > span > svg': {
          color: theme.palette.common.ceriseRed,
        },
      },
    },
    fullWidth: {
      width: '100%',
    },
  }),
  { name: 'DatePicker' }
);

interface GcpDateRangePickerProps {
  openCalendar: boolean;
  date: DateRange<Date>;
  handleOnClick: () => void;
  handleOnClear: (event: MouseEvent<HTMLOrSVGElement>) => void;
  handleOnChange: (date: DateRange<Date>) => void;
  handleOnClose: () => void;
  fullWidth?: boolean;
  disableFuture?: boolean;
}

const GcpDateRangePicker: FC<GcpDateRangePickerProps> = (props) => {
  const classes = useStyles();
  const {
    openCalendar,
    date,
    handleOnClick,
    handleOnClear,
    handleOnChange,
    handleOnClose,
    fullWidth,
    disableFuture,
  } = props;

  return (
    <DateRangePicker
      disableFuture={disableFuture}
      open={openCalendar}
      renderInput={() => (
        <Button
          className={clsx(classes.container, {
            [classes.fullWidth]: fullWidth,
          })}
          onClick={handleOnClick}
        >
          {date[0] ? (
            <>
              {getDatetimeText(date[0], 'numericDate')}
              <ArrowRightAltIcon className={classes.icon} />
            </>
          ) : (
            'Any Time'
          )}
          {date[1] && getDatetimeText(date[1], 'numericDate')}
          {date[0] && date[1] ? (
            <CloseIcon className={classes.icon} onClick={handleOnClear} />
          ) : (
            <CalendarTodayOutlinedIcon className={classes.icon} />
          )}
        </Button>
      )}
      value={date}
      onChange={handleOnChange}
      onClose={handleOnClose}
    />
  );
};

export default GcpDateRangePicker;
